/* Cimafer · Vitrine (esteira contínua) com arrastar + controles
   Motor único p/ cima-offers, cima-mais-vendidos e cima-vistos-recentemente.
   RESTAURADO 30/jul (pedido do dono): o scroll-snap card-a-card ficou "1 por 1
   e lento" — volta o movimento contínuo suave. Card compacto 252px mantido.
   - Movimento contínuo via requestAnimationFrame (transform translate3d), px/s constante.
   - Loop sem emenda: 2 grupos idênticos, offset envolto em (-copyW, 0].
     Se a seção renderiza só 1 grupo (server), o motor CLONA (aria-hidden,
     sem data-ga-list → GA continua contando 1x).
   - Arrastar: cursor grab/grabbing, puxa a esteira (pausa enquanto arrasta).
   - Controles: voltar · pausar/retomar · avançar (passo = 1 card, com easing).
   Marcação esperada dentro de [data-cima-vitrine]:
     .cima-vitrine__track > .cima-vitrine__group (1º = real/GA) [+ clone aria-hidden]
   Controles (irmãos, dentro do <section>): [data-vitrine-prev|toggle|next] */
(function () {
  if (window.__cimaVitrine) return;
  window.__cimaVitrine = true;

  var BASE = 14; // px/s por unidade de velocidade (setting 1-10)
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

  function init(root) {
    var track = root.querySelector('.cima-vitrine__track');
    var group = root.querySelector('.cima-vitrine__group');
    if (!track || !group) return;      // ainda não montou (ex.: Vistos) — tenta no próximo boot
    if (root.__v) return; root.__v = true;

    // Loop sem emenda exige 2 cópias; server manda 1 grupo → clona aqui.
    if (track.querySelectorAll('.cima-vitrine__group').length === 1) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-ga-list');
      clone.querySelectorAll('a,button,input').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
    }

    var pxs = (parseFloat(root.getAttribute('data-vitrine-speed')) || 5) * BASE;
    var copyW = 0, offset = 0, last = 0;
    var paused = root.getAttribute('data-vitrine-autoplay') === 'false';
    var hover = false, dragging = false, tweening = false, off = false;

    function measure() { copyW = group.getBoundingClientRect().width; }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    function wrap() { if (copyW > 0) { while (offset <= -copyW) offset += copyW; while (offset > 0) offset -= copyW; } }
    function apply() { track.style.transform = 'translate3d(' + offset + 'px,0,0)'; }

    function frame(ts) {
      var dt = (last ? ts - last : 0) / 1000; last = ts;
      if (!paused && !hover && !dragging && !tweening && !off && !document.hidden && copyW > 0) {
        offset -= pxs * dt; wrap(); apply();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    // Pausa ao passar o mouse / foco (deixa ler e clicar).
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; last = 0; });
    root.addEventListener('focusin', function () { hover = true; });
    root.addEventListener('focusout', function () { hover = false; last = 0; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { off = !e.isIntersecting; }); last = 0; }, { threshold: 0 }).observe(root);
    }

    // ── Arrastar (grab) ────────────────────────────────────
    // IMPORTANTE: só vira "arraste" (e captura o ponteiro) depois de mover >6px.
    // Assim o clique simples NUNCA é capturado → o link/botão do card funciona.
    var THRESH = 6;
    var sx = 0, so = 0, pressing = false, didDrag = false, pid = null;
    function down(e) {
      pressing = true; dragging = false; didDrag = false;
      sx = e.touches ? e.touches[0].clientX : e.clientX; so = offset;
      pid = (e.pointerId != null) ? e.pointerId : null;
    }
    function mv(e) {
      if (!pressing) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      var d = x - sx;
      if (!dragging) {
        if (Math.abs(d) < THRESH) return;      // ainda é (provável) clique → não interfere
        dragging = true; didDrag = true; last = 0;
        root.classList.add('is-grabbing');
        if (pid != null) { try { track.setPointerCapture(pid); } catch (_) {} }
      }
      offset = so + d; wrap(); apply();
      if (e.cancelable) e.preventDefault();
    }
    function up() {
      pressing = false;
      if (dragging) {
        dragging = false; last = 0; root.classList.remove('is-grabbing');
        if (pid != null) { try { track.releasePointerCapture(pid); } catch (_) {} }
      }
      pid = null;
    }
    if (window.PointerEvent) {
      track.addEventListener('pointerdown', down);
      window.addEventListener('pointermove', mv, { passive: false });
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    } else {
      track.addEventListener('mousedown', down);
      window.addEventListener('mousemove', mv);
      window.addEventListener('mouseup', up);
      track.addEventListener('touchstart', down, { passive: true });
      track.addEventListener('touchmove', mv, { passive: false });
      track.addEventListener('touchend', up);
    }
    // Só suprime o clique se houve arraste de verdade; clique simples passa direto.
    track.addEventListener('click', function (e) { if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; } }, true);

    // ── Controles ──────────────────────────────────────────
    function stepPx() {
      var c = group.querySelector('.cima-card-produto');
      var gap = parseInt(getComputedStyle(group).columnGap || '16', 10) || 16;
      return (c ? c.getBoundingClientRect().width : 252) + gap;
    }
    function tween(delta) {
      tweening = true; var s0 = offset, t0 = null, dur = 460;
      function t(ts) {
        if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        offset = s0 + delta * e; wrap(); apply();
        if (k < 1) requestAnimationFrame(t); else { tweening = false; last = 0; }
      }
      requestAnimationFrame(t);
    }
    var section = root.closest('section') || root.parentNode;
    var prev = section.querySelector('[data-vitrine-prev]');
    var next = section.querySelector('[data-vitrine-next]');
    var toggle = section.querySelector('[data-vitrine-toggle]');
    if (prev) prev.addEventListener('click', function () { tween(stepPx()); });   // voltar → conteúdo p/ direita
    if (next) next.addEventListener('click', function () { tween(-stepPx()); });  // avançar → p/ esquerda
    function reflect() {
      if (!toggle) return;
      toggle.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
      toggle.setAttribute('aria-label', paused ? 'Retomar' : 'Pausar');
      toggle.setAttribute('aria-pressed', String(paused));
    }
    if (toggle) toggle.addEventListener('click', function () { paused = !paused; last = 0; reflect(); });
    reflect();
  }

  function boot() {
    var list = document.querySelectorAll('[data-cima-vitrine]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Vistos monta os cards depois (assíncrono) → re-boot quando renderiza.
  document.addEventListener('cima:recs:rendered', boot);
  window.cimaVitrineBoot = boot;
})();
